import { Image } from '@bfe/moly';
import { GroupReward } from './getGroupRewards';

type GroupRewardsProps = {
  groupRewards: GroupReward[];
};

export const GroupRewardList = ({ groupRewards }: GroupRewardsProps) => {
  return (
    <div className="flex flex-col bg-[#101014] rounded-lg">
      {groupRewards.map((reward) => (
        <div
          key={reward.rewardToken}
          className="flex px-5 py-3 items-center justify-between"
        >
          <div className="flex items-center gap-2">
            <Image
              src={reward.tokenIcon}
              alt={reward.rewardToken}
              className="w-8 h-8"
            />
            <div className="text-2xl">{reward.rewardToken}</div>
          </div>
          <div className="font-semibold text-2xl">{reward.totalAmount}</div>
        </div>
      ))}
    </div>
  );
};
